import React, { useState } from "react";
import { Box, Typography, Collapse } from "@mui/material";
import { useTheme } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import JsonView from "@uiw/react-json-view";
const JsonSection = ({ title, data }: { title: string; data: any }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  if (!data) return null;

  return (
    <Box>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1,
          py: 2,
          borderRadius: 1,
          cursor: "pointer",

          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.04)",
          },
        }}
      >
        <Typography fontSize={12} fontWeight={600}>
          {title}
        </Typography>

        <ExpandMore
          sx={{
            fontSize: 18,
            transition: "0.2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Box>

      <Collapse in={open}>
        <Box
          sx={{
            borderRadius: 1,
            overflow: "hidden",
            border: "1px solid rgba(255,255,255,0.1)",
            mt: 0.5,
          }}
        >
          <JsonView
            value={data}
            collapsed={2}
            displayDataTypes={false}
            displayObjectSize={false}
            style={
              {
                fontSize: 11,
                backgroundColor: "transparent",
                padding: 8,
                fontFamily: "JetBrains Mono, monospace",
                "--w-rjv-key-string":
                  theme.palette.mode === "dark" ? "#38bdf8" : "#002b36",
              } as React.CSSProperties
            }
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default JsonSection